module.exports = __webpack_public_path__ + "static/wix_1-406c3d13e5b7f709c7c31dc460035c34.png";